import { Divider, Button } from 'antd';
import React, { useLayoutEffect } from 'react';
import { useHistory }  from 'react-router-dom';
import { getParamFromUrl } from '@/infrastructure/history';
import { decodeRemark } from '@/infrastructure/utils/str';

const ExternalLink = () => {
  const url = getParamFromUrl('url');
  console.log('External Link');
  const history = useHistory();

  useLayoutEffect(() => {
    if (!url) {
      history.push('/index/main');
    }
  }, []);

  const access = () => {
    location.replace(decodeRemark(url));
  };

  return <div className={'w-full h-full bg-[#f4f5f5] flex justify-center'}>
    <div className={'rounded-[6px] px-[30px] py-[30px] mt-[400px] bg-[#fff] h-[200px] w-[600px] border border-[#e5e6eb] border-solid'}>
      <p className={'text-[18px] font-medium mb-[16px]'}>即将离开Bugly，请注意账号财产安全</p>
      <span className={'text-[14px] text-[#808080]'}>{decodeRemark(url)}</span>
      <Divider/>
      <div className={'text-right'}>
        <Button type={'primary'} onClick={access}>继续访问</Button>
      </div>
    </div>
  </div>;
};

export default ExternalLink;
